export const AD_BUILDER = 'adbuilder'
export const ANNOUNCEMENTS = 'announcements'
export const COMMAND_BOT = 'commandbot'
export const FOUNDBYSAM = 'foundbysam'
export const HUB = 'hub'
export const PMKTRADE = 'pmktrade'
export const POLLS = 'polls'
export const PORTFOLIO = 'portfolio'
export const PRESTREAM = 'prestream'
export const PRIVATE_CHAT = 'privatechat'
export const PUBLIC_CHAT = 'publicchat'
export const SCANNER = 'scanner'
export const TRADES = 'trades'
export const LIMITED_ACCESS = 'limitedaccess'
export const QUESTIONS = 'questions'
